import axios from "axios";

export const documentTypes = [
  { key: "Acctg_Journal", value: "Acctg Journal" },
  { key: "Agency", value: "Agency" },
  { key: "Beacon_System", value: "Beacon System" },
  { key: "Bonds", value: "Bonds" },
  { key: "Claim", value: "Claim" },
  { key: "Current_Carrier", value: "Current Carrier" },
  { key: "ECA_Security", value: "ECA Security" },
  { key: "Owned_Prop", value: "Owned Prop" },
  { key: "Patrons_System", value: "Patrons System" },
  { key: "Policy", value: "Policy" },
  { key: "Policy_Decline", value: "Policy Decline" },
  { key: "Producer", value: "Producer" },
  { key: "RTW_System", value: "RTW System" },
  { key: "Large_Line_Dec", value: "Large Line Dec" },
  { key: "AP_Docs", value: "AP Docs" },
  { key: "Policy_Forms", value: "Policy Forms" },
  { key: "HR", value: "HR" },
  { key: "HR_Credit", value: "HR Credit" },
  { key: "HR_Relocate", value: "HR Relocate" },
  { key: "HR_MVR", value: "HR MVR" },
  { key: "Employee_File", value: "Employee File" },
  { key: "Red_Deal", value: "Red Deal" },
  { key: "Claim_Data", value: "Claim Data" },
  { key: "Bill_Data", value: "Bill Data" },
  { key: "Comm_Adjust", value: "Comm Adjust" },
  { key: "Contracts", value: "Contracts" },
  { key: "Data_Quality", value: "Data Quality" },
  { key: "DC_Audit", value: "DC Audit" },
  { key: "Delinquent_Let", value: "Delinquent Let" },
  { key: "HR_LDR_COMP", value: "HR LDR COMP" },
  { key: "Internal_Audit", value: "Internal Audit" },
  { key: "Inv_Confirmation", value: "Inv Confirmation" },
  { key: "Lease", value: "Lease" },
  { key: "Loss_Control_Reg", value: "Loss Control Reg" },
  { key: "OFAC", value: "OFAC" },
  { key: "Policy_Complaint", value: "Policy Complaint" },
  { key: "Producer_Docs", value: "Producer Docs" },
  { key: "R3_Contracts", value: "R3 Contracts" },
  { key: "ReIns_Assumed", value: "ReIns Assumed" },
  { key: "Rhode_Is_AIP", value: "Rhode Is AIP" },
  { key: "Agency_Docs", value: "Agency Docs" },
  { key: "Acct_Recon", value: "Acct Recon" },
  { key: "Acctg_Agency", value: "Acctg Agency" },
  { key: "Investments", value: "Investments" },
  { key: "Adj_Files", value: "Adj Files" },
  { key: "Admin_Envelopes", value: "Admin Envelopes" },
  { key: "Admin_Forms", value: "Admin Forms" },
  { key: "Bnk_Recon-BR", value: "Bnk Recon-BR" },
  { key: "Bnk_Recon-Corp", value: "Bnk Recon-Corp" },
  { key: "HR_Credit_Card", value: "HR Credit Card" },
  { key: "Hurricane_CAT", value: "Hurricane CAT" },
  { key: "ITV_Project", value: "ITV Project" },
  { key: "Assn_Corporate", value: "Assn Corporate" },
  { key: "Assn_Programs", value: "Assn Programs" },
  { key: "Audit_F_Drive", value: "Audit F Drive" },
  { key: "Audit_LADM", value: "Audit LADM" },
  { key: "Audit_Mainframe", value: "Audit Mainframe" },
  { key: "Audit_MB_Admin", value: "Audit MB Admin" },
  { key: "Audit_MB_User", value: "Audit MB User" },
  { key: "Audit_SharePoint", value: "Audit SharePoint" },
];

export const defaultDocumentTypes = [
  { key: "Acctg_Journal", value: "Acctg Journal" },
  { key: "Agency", value: "Agency" },
  { key: "Beacon_System", value: "Beacon System" },
  { key: "Bonds", value: "Bonds" },
  { key: "Claim", value: "Claim" },
  { key: "Current_Carrier", value: "Current Carrier" },
  { key: "ECA_Security", value: "ECA Security" },
  { key: "Investments", value: "Investments" },
  { key: "Owned_Prop", value: "Owned Prop" },
  { key: "Patrons_System", value: "Patrons System" },
  { key: "Policy", value: "Policy" },
  { key: "Policy_Decline", value: "Policy Decline" },
  { key: "Producer", value: "Producer" },
  { key: "Red_Deal", value: "Red Deal" },
  { key: "RTW_System", value: "RTW System" },
]

export const HRDocumentTypes = [
  { key: "Acctg_Journal", value: "Acctg Journal" },
  { key: "Agency", value: "Agency" },
  { key: "Beacon_System", value: "Beacon System" },
  { key: "Bonds", value: "Bonds" },
  { key: "Claim", value: "Claim" },
  { key: "Current_Carrier", value: "Current Carrier" },
  { key: "ECA_Security", value: "ECA Security" },
  { key: "Investments", value: "Investments" },
  { key: "Owned_Prop", value: "Owned Prop" },
  { key: "Patrons_System", value: "Patrons System" },
  { key: "Policy", value: "Policy" },
  { key: "Policy_Decline", value: "Policy Decline" },
  { key: "Producer", value: "Producer" },
  { key: "Red_Deal", value: "Red Deal" },
  { key: "RTW_System", value: "RTW System" },
  { key: "HR_Credit_Card", value: "HR Credit Card" },
  { key: "HR", value: "HR" },
]

export const UWDocumentTypes = [
  { key: "Acctg_Journal", value: "Acctg Journal" },
  { key: "Agency", value: "Agency" },
  { key: "Beacon_System", value: "Beacon System" },
  { key: "Bonds", value: "Bonds" },
  { key: "Claim", value: "Claim" },
  { key: "Current_Carrier", value: "Current Carrier" },
  { key: "ECA_Security", value: "ECA Security" },
  { key: "Investments", value: "Investments" },
  { key: "Owned_Prop", value: "Owned Prop" },
  { key: "Patrons_System", value: "Patrons System" },
  { key: "Policy", value: "Policy" },
  { key: "Policy_Decline", value: "Policy Decline" },
  { key: "Producer", value: "Producer" },
  { key: "Red_Deal", value: "Red Deal" },
  { key: "RTW_System", value: "RTW System" },
  { key: "Large_Line_Dec", value: "Large Line Dec" },
]

export const getDocumentType = (userPermissions) => {
  // console.log("userPermissions",userPermissions)
  // let getType = {
  //   user_group: userPermissions
  // }
  // try {
  //   const response = axios.post(
  //     "https://api-send2sacc.msp0005.stateauto.com/UserGroupDocuments",
  //     getType
  //   );
  //   console.log(response);
  //   return response
  // } catch (error) {
  //   console.error("Error fetching document types:", error);
  //   return [];
  // }


  // console.log("userPermissions", userPermissions)
  // console.log("userPermissions", userPermissions)
  if (userPermissions.groups.includes("gets-Send2SACC_IT")) {
    // console.log("belongs to IT group")
    return documentTypes
  }
  if (userPermissions.groups.includes("gets-Send2SACC_UW")) {
    // console.log("belongs to UW group")
    return UWDocumentTypes
  }
  if (userPermissions.groups.includes("gets-Send2SACC_HR")) {
    // console.log("belongs to HR group")
    return HRDocumentTypes
  }
  if (userPermissions.groups.includes("gets-Send2SACC")) {
    // console.log("belongs to Default group")
    return defaultDocumentTypes
  }



  // if (userPermissions === "admin") {
  //   return defaultDocumentTypes
  //   // return documentTypes

  // }
  // else {
  //   return defaultDocumentTypes
  // }

}

export const getDescriptionItems = (documentType, type = "cat") => {
  // console.log("getDescriptionItems", documentType, type)
  const descriptionsMap = {
    Policy: [
      { key: "ADF - U/W Notes", value: "ADF - U/W Notes" },
      { key: "AGT/INS LETTER", value: "AGT/INS LETTER" },
      { key: "APPLICATION", value: "APPLICATION" },
      { key: "APPRAISAL", value: "APPRAISAL" },
      { key: "AUDIT", value: "AUDIT" },
      { key: "AUTHORIZATION", value: "AUTHORIZATION" },
      { key: "AUTO EXP RATING", value: "AUTO EXP RATING" },
      { key: "BLANKET INVENTORY", value: "BLANKET INVENTORY" },
      { key: "BRANCH QUOTE", value: "BRANCH QUOTE" },
      { key: "CANC/REINST/NR", value: "CANC/REINST/NR" },
      { key: "CERTIFICATE", value: "CERTIFICATE" },
      { key: "CERTIFIED MAIL", value: "CERTIFIED MAIL" },
      { key: "CLUE REPORT", value: "CLUE REPORT" },
      { key: "COMPLAINT", value: "COMPLAINT" },
      { key: "COURT DOCUMENTS", value: "COURT DOCUMENTS" },
      { key: "CREDIT REPORT", value: "CREDIT REPORT" },
      { key: "DEC PAGE", value: "DEC PAGE" },
      { key: "DRIVER EX FORM", value: "DRIVER EX FORM" },
      { key: "ENDORSEMENT", value: "ENDORSEMENT" },
      { key: "EPAY AUTH", value: "EPAY AUTH" },
      { key: "EVIDENCE OF PROP", value: "EVIDENCE OF PROP" },
      { key: "EXP MOD RATING", value: "EXP MOD RATING" },
      { key: "FINANCIAL RESP", value: "FINANCIAL RESP" },
      { key: "FS1/FS4 REPORT", value: "FS1/FS4 REPORT" },
      { key: "INSPECTION", value: "INSPECTION" },
      { key: "ISO SPECIFIC RATES", value: "ISO SPECIFIC RATES" },
      { key: "LARGE LOSS REVIEW", value: "LARGE LOSS REVIEW" },
      { key: "LOSS HISTORY", value: "LOSS HISTORY" },
      { key: "MEMORANDUM", value: "MEMORANDUM" },
      { key: "MISCELLANEOUS", value: "MISCELLANEOUS" },
      { key: "MOTOR VEH RPT", value: "MOTOR VEH RPT" },
      { key: "OPTION SELECTOR", value: "OPTION SELECTOR" },
      { key: "PHYSICIAN REPORTS", value: "PHYSICIAN REPORTS" },
      { key: "PICTURE", value: "PICTURE" },
      { key: "QUESTIONNAIRES", value: "QUESTIONNAIRES" },
      { key: "REINS QUOTE", value: "REINS QUOTE" },
      { key: "REINS CERT", value: "REINS CERT" },
      { key: "REPL COST EST", value: "REPL COST EST" },
      { key: "REPORTED VALUES", value: "REPORTED VALUES" },
      { key: "RETURNED MAIL", value: "RETURNED MAIL" },
      { key: "SCHEDULE", value: "SCHEDULE" },
      { key: "STMT OF NO LOSSES", value: "STMT OF NO LOSSES" },
      { key: "UMB WORKSHEET", value: "UMB WORKSHEET" },
      { key: "UNDER NOTES", value: "UNDER NOTES" },
      { key: "UW Documentation", value: "UW Documentation" }
    ],

    Acctg_Journal: [{ key: type, value: type }],
    Agency: [
      { key: "6 MONTH SETTLE UP", value: "6 MONTH SETTLE UP" },
      { key: "AGENCY ISSUE", value: "AGENCY ISSUE" },
      { key: "CLAIM ISSUE", value: "CLAIM ISSUE" },
      { key: "SALES ISSUE", value: "SALES ISSUE" },
      { key: "UNDERWRITING ISSUE", value: "UNDERWRITING ISSUE" }
    ],
    ITV_Project: [
      { key: type + " Inspection", value: type + " Inspection" },
      { key: type + " RCE", value: type + " RCE" },
      { key: type + " Profile", value: type + " Profile" },
      { key: type + " Survey", value: type + " Survey" },
    ],

    RTW_System: [
      { key: type + " Application", value: type + " Application" },
      { key: type + " Dec Page", value: type + " Dec Page" },
      { key: type + " Endorsement", value: type + " Endorsement" },
      { key: type + " Loss History", value: type + " Loss History" },
      { key: type + " Miscellaneous", value: type + " Miscellaneous" },
      { key: type + " Under Notes", value: type + " Under Notes" },
    ],

    Beacon_System: [
      { key: type + " LETTER", value: type + " LETTER" },
    ],

    Bonds: [
      { key: type + " AGT/INS LETTER", value: type + " AGT/INS LETTER" },
      { key: type + " APPLICATION", value: type + " APPLICATION" },
      { key: type + " AUDIT", value: type + " AUDIT" },
      { key: type + " BID BOND", value: type + " BID BOND" },
      { key: type + " BID REQUEST", value: type + " BID REQUEST" },
      { key: type + " BID RESULTS", value: type + " BID RESULTS" },
      { key: type + " BILLING NOTICE", value: type + " BILLING NOTICE" },
      { key: type + " BOND POLICY", value: type + " BOND POLICY" },
      { key: type + " CANCELATION DOC", value: type + " CANCELATION DOC" },
      { key: type + " CERT MAIL DOC", value: type + " CERT MAIL DOC" },
      { key: type + " CERT OF INS", value: type + " CERT OF INS" },
      { key: type + " CERTIFIED NOTICE", value: type + " CERTIFIED NOTICE" },
      { key: type + " CHANGE REQUEST", value: type + " CHANGE REQUEST" },
      { key: type + " CONSENT OF SURETY", value: type + " CONSENT OF SURETY" },
      { key: type + " CONTRACT AGREEMENT", value: type + " CONTRACT AGREEMENT" },
      { key: type + " CONTRACT SPEC", value: type + " CONTRACT SPEC" },
      { key: type + " COURT DOC", value: type + " COURT DOC" },
      { key: type + " COURT RELEASE", value: type + " COURT RELEASE" },
      { key: type + " CREDIT REPORT", value: type + " CREDIT REPORT" },
      { key: type + " DUAL OBLIGEE", value: type + " DUAL OBLIGEE" },
      { key: type + " ENDORSEMENT", value: type + " ENDORSEMENT" },
      { key: type + " FINANCIAL REPORT", value: type + " FINANCIAL REPORT" },
      { key: type + " GEN IND AGREEMENT", value: type + " GEN IND AGREEMENT" },
      { key: type + " LETTER OF CANCEL", value: type + " LETTER OF CANCEL" },
      { key: type + " MEMORANDUM", value: type + " MEMORANDUM" },
      { key: type + " MISCELLANEOUS", value: type + " MISCELLANEOUS" },
      { key: type + " NON RENEW DOCUMENT", value: type + " NON RENEW DOCUMENT" },
      { key: type + " NOTICE OF FURNISH", value: type + " NOTICE OF FURNISH" },
      { key: type + " PROD ORDER BLANK", value: type + " PROD ORDER BLANK" },
      { key: type + " QUOTATION", value: type + " QUOTATION" },
      { key: type + " REINSTATEMENT", value: type + " REINSTATEMENT" },
      { key: type + " RENEWAL APP", value: type + " RENEWAL APP" },
      { key: type + " SCHEDULE COVERAGE", value: type + " SCHEDULE COVERAGE" },
      { key: type + " STATUS INQUIRY", value: type + " STATUS INQUIRY" },
      { key: type + " TERRORISM ACT", value: type + " TERRORISM ACT" },
      { key: type + " UND AUTHORITY", value: type + " UND AUTHORITY" }
    ],
    Current_Carrier: (() => {
      const descriptions = [];
      for (let i = 0; i < 3; i++) {
        let date = new Date();
        date.setDate(date.getDate() - i);
        descriptions[i] = {
          key: date.toLocaleDateString('en-US'),
          value: date.toLocaleDateString('en-US'),
        };
      }
      return descriptions;
    })(),
    Investments: (() => {
      const descriptions = [];
      for (let i = 0; i < 15; i++) {
        let date = new Date();
        date.setDate(date.getDate() - i);
        descriptions[i] = {
          key: date.toLocaleDateString('en-US'),
          value: date.toLocaleDateString('en-US'),
        };
      }
      return descriptions;
    })(),
    Large_Line_Dec: [
      { key: type + " Amendment", value: type + " Amendment" },
      { key: type + " New", value: type + " New" },
      { key: type + " Renewal", value: type + " Renewal" }
    ],
    Agency_Docs: [
      { key: type + " Affect Agcy Data", value: type + " Affect Agcy Data" },
      { key: type + " Agreements", value: type + " Agreements" },
      { key: type + " To From Agency", value: type + " To From Agency" },
      { key: type + " Any Other", value: type + " Any Other" },
      { key: type + " Original", value: type + " Original" },
      { key: type + " New Agcy Paperwork", value: type + " New Agcy Paperwork" },
      { key: type + " Licenses Cert", value: type + " Licenses Cert" },
      { key: type + " State Forms Ltrs", value: type + " State Forms Ltrs" }
    ],
    Producer: [
      { key: "AGENCY ISSUE", value: "AGENCY ISSUE" },
      { key: "CLAIM ISSUE", value: "CLAIM ISSUE" },
      { key: "SALES ISSUE", value: "SALES ISSUE" },
      { key: "UNDERWRITING ISSUE", value: "UNDERWRITING ISSUE" }
    ],
    ECA_Security: [
      { key: type + " - ", value: type + " - " },
      { key: type + " - Term HelpDesk", value: type + " - Term HelpDesk" },
      { key: type + " - Term Response", value: type + " - Term Response" },
      { key: type + " - Change Response", value: type + " - Change Response" }
    ],

    Owned_Prop: [
      { key: "Addendums", value: "Addendums" },
      { key: "Affidavits", value: "Affidavits" },
      { key: "Agreements", value: "Agreements" },
      { key: "Amendments", value: "Amendments" },
      { key: "Appraisals", value: "Appraisals" },
      { key: "Architectural", value: "Architectural" },
      { key: "Attorney Corr", value: "Attorney Corr" },
      { key: "CAD Prints", value: "CAD Prints" },
      { key: "Certificate Corr", value: "Certificate Corr" },
      { key: "Close Settlement", value: "Close Settlement" },
      { key: "Correspondence", value: "Correspondence" },
      { key: "Deeds", value: "Deeds" },
      { key: "Earnest Money", value: "Earnest Money" },
      { key: "Easement", value: "Easement" },
      { key: "Environmental", value: "Environmental" },
      { key: "Grantee State", value: "Grantee State" },
      { key: "Improvements", value: "Improvements" },
      { key: "Insurance", value: "Insurance" },
      { key: "Licenses Agreement", value: "Licenses Agreement" },
      { key: "Maps", value: "Maps" },
      { key: "Mortgage Notes", value: "Mortgage Notes" },
      { key: "POA", value: "POA" },
      { key: "Photos", value: "Photos" },
      { key: "Purchase Sale", value: "Purchase Sale" },
      { key: "Table of Contents", value: "Table of Contents" },
      { key: "Tax", value: "Tax" }
    ],

    Patrons_System: [
      { key: type + " AGT/INS LETTER", value: type + " AGT/INS LETTER" },
      { key: type + " APPLICATION", value: type + " APPLICATION" },
      { key: type + " APPRAISAL", value: type + " APPRAISAL" },
      { key: type + " AUDIT", value: type + " AUDIT" },
      { key: type + " AUTHORIZATION", value: type + " AUTHORIZATION" },
      { key: type + " AUTO EXP RATING", value: type + " AUTO EXP RATING" },
      { key: type + " BLANKET INVENTORY", value: type + " BLANKET INVENTORY" },
      { key: type + " BRANCH QUOTE", value: type + " BRANCH QUOTE" },
      { key: type + " CANC/REINST/NR", value: type + " CANC/REINST/NR" },
      { key: type + " CERTIFICATE", value: type + " CERTIFICATE" },
      { key: type + " CLUE REPORT", value: type + " CLUE REPORT" },
      { key: type + " CONVERSION", value: type + " CONVERSION" },
      { key: type + " COURT DOCUMENTS", value: type + " COURT DOCUMENTS" },
      { key: type + " CREDIT REPORT", value: type + " CREDIT REPORT" },
      { key: type + " DEC PAGE", value: type + " DEC PAGE" },
      { key: type + " DRIVER EX FORM", value: type + " DRIVER EX FORM" },
      { key: type + " ENDORSEMENT", value: type + " ENDORSEMENT" },
      { key: type + " EVIDENCE OF PROP", value: type + " EVIDENCE OF PROP" },
      { key: type + " EXP MOD RATING", value: type + " EXP MOD RATING" },
      { key: type + " FINANCIAL RESP", value: type + " FINANCIAL RESP" },
      { key: type + " FS1/FS4 REPORT", value: type + " FS1/FS4 REPORT" },
      { key: type + " INSPECTION", value: type + " INSPECTION" },
      { key: type + " ISO SPECIFIC RATES", value: type + " ISO SPECIFIC RATES" },
      { key: type + " LOSS HISTORY", value: type + " LOSS HISTORY" },
      { key: type + " MEMORANDUM", value: type + " MEMORANDUM" },
      { key: type + " MISCELLANEOUS", value: type + " MISCELLANEOUS" },
      { key: type + " MOTOR VEH RPT", value: type + " MOTOR VEH RPT" },
      { key: type + " OPTION SELECTOR", value: type + " OPTION SELECTOR" },
      { key: type + " PHYSICIAN REPORTS", value: type + " PHYSICIAN REPORTS" },
      { key: type + " PICTURE", value: type + " PICTURE" },
      { key: type + " QUESTIONNAIRES", value: type + " QUESTIONNAIRES" },
      { key: type + " REINS QUOTE", value: type + " REINS QUOTE" },
      { key: type + " REINS CERT", value: type + " REINS CERT" },
      { key: type + " REPL COST EST", value: type + " REPL COST EST" },
      { key: type + " REPORTED VALUES", value: type + " REPORTED VALUES" },
      { key: type + " SCHEDULE", value: type + " SCHEDULE" },
      { key: type + " STMT OF NO LOSSES", value: type + " STMT OF NO LOSSES" },
      { key: type + " UMB WORKSHEET", value: type + " UMB WORKSHEET" },
      { key: type + " UNDER NOTES", value: type + " UNDER NOTES" }
    ],

    HR_Credit_Card: [
      { key: "NCB CARD APP", value: "NCB CARD APP" },
    ],

    Claim: [
      { key: "ALE", value: "ALE" },
      { key: "AUTO TITLE WORK", value: "AUTO TITLE WORK" },
      { key: "AUTO TOTAL LOSS", value: "AUTO TOTAL LOSS" },
      { key: "BUSINESS INTERRUPT", value: "BUSINESS INTERRUPT" },
      { key: "CNTS INVENTORIES", value: "CNTS INVENTORIES" },
      { key: "LEGAL DOCUMENTS", value: "LEGAL DOCUMENTS" },
      { key: "LOSS REPORT", value: "LOSS REPORT" },
      { key: "MEDS-BI/UMBI", value: "MEDS-BI/UMBI" },
      { key: "MEDS-MED PAY/PIP", value: "MEDS-MED PAY/PIP" },
      { key: "MISCELLANEOUS", value: "MISCELLANEOUS" },
      { key: "NI APPRAISAL", value: "NI APPRAISAL" },
      { key: "NI AUTO RENTAL", value: "NI AUTO RENTAL" },
      { key: "NI ESTIMATE", value: "NI ESTIMATE" },
      { key: "NI PHOTOS", value: "NI PHOTOS" },
      { key: "PD APPRAISAL", value: "PD APPRAISAL" },
      { key: "PD AUTO RENTAL", value: "PD AUTO RENTAL" },
      { key: "PD ESTIMATE", value: "PD ESTIMATE" },
      { key: "PD PHOTOS", value: "PD PHOTOS" },
      { key: "POLICE/FIRE RPTS", value: "POLICE/FIRE RPTS" },
      { key: "RECEIPTS", value: "RECEIPTS" },
      { key: "REC CLMT", value: "REC CLMT" },
      { key: "REC MISC", value: "REC MISC" },
      { key: "REC INS", value: "REC INS" },
      { key: "REC WIT", value: "REC WIT" },
      { key: "SCHED ITEMS/EQUIP", value: "SCHED ITEMS/EQUIP" },
      { key: "SUBRO-PD CARRIER", value: "SUBRO-PD CARRIER" }
    ],

    Producer_Docs: [
      { key: type + " Affect Agcy Data", value: type + " Affect Agcy Data" },
      { key: type + " To From Agency", value: type + " To From Agency" },
      { key: type + " Any Other", value: type + " Any Other" },
      { key: type + " Original", value: type + " Original" },
      { key: type + " Licenses Cert", value: type + " Licenses Cert" },
      { key: type + " State Forms Ltrs", value: type + " State Forms Ltrs" }
    ],
    HR: {
      Attendance: [
        { key: "FMLA", value: "FMLA" },
        { key: "LTD", value: "LTD" },
        { key: "MISC", value: "MISC" },
        { key: "STD", value: "STD" },
        { key: "WC", value: "WC" },
      ],
      Benefits: [
        { key: "401k BENEFICIARY", value: "401k BENEFICIARY" },
        { key: "401k LOANS", value: "401k LOANS" },
        { key: "401k QDRO", value: "401k QDRO" },
        { key: "401k WITHDRAWALS", value: "401k WITHDRAWALS" },
        { key: "401k Rollover", value: "401k Rollover" },
        { key: "LIFE INS BENEFICIARY", value: "LIFE INS BENEFICIARY" },
        { key: "GROUP INS ENROLL", value: "GROUP INS ENROLL" },
        { key: "PENSION ACTIVE", value: "PENSION ACTIVE" },
        { key: "PENSION ELECTION", value: "PENSION ELECTION" },
        { key: "PENSION QDRO", value: "PENSION QDRO" },
        { key: "PENSION RETIRED", value: "PENSION RETIRED" },
        { key: "PENSION TERM VEST", value: "PENSION TERM VEST" },
        { key: "PENSION TRANSFER", value: "PENSION TRANSFER" }
      ],
      Payroll: [
        { key: "Job Change", value: "Job Change" },
        { key: "Misc", value: "Misc" },
        { key: "Salary", value: "Salary" },
      ],
      Personal: [
        { key: "Address", value: "Address" },
        { key: "Court", value: "Court" },
        { key: "Misc", value: "Misc" },
        { key: "Taxes", value: "Taxes" },
      ],
      Termination: [
        { key: "Employee File", value: "Employee File" },
      ],
      Welfare_Benefits: [
        { key: "Aflac", value: "Aflac" },
        { key: "Col Sav 529", value: "Col Sav 529" },
        { key: "Dental", value: "Dental" },
        { key: "EAP", value: "EAP" },
        { key: "Flex", value: "Flex" },
        { key: "HSA", value: "HSA" },
        { key: "Life Beneficiaries", value: "Life Beneficiaries" },
        { key: "Life Insurance", value: "Life Insurance" },
        { key: "Mass Mutual", value: "Mass Mutual" },
        { key: "Medical", value: "Medical" },
        { key: "Notices", value: "Notices" },
        { key: "Vision", value: "Vision" },
        { key: "VPP", value: "VPP" }
      ],
    },

    Red_Deal: {
      FSM_Companion: [{ key: "WCP", value: "WCP" }],
      FSM_Rockhill: [{ key: "EBL", value: "EBL" }],
      FSM_State_National: [
        { key: "AUTO", value: "AUTO" },
        { key: "GL", value: "GL" },
        { key: "WCP", value: "WCP" },
      ],
      RSC_Companion: [
        { key: "AUTO", value: "AUTO" },
        { key: "BOP", value: "BOP" },
        { key: "WCP", value: "WCP" },
      ],
      RSC_Plaza: [
        { key: "AUTO", value: "AUTO" },
        { key: "PACKAGE", value: "PACKAGE" },
        { key: "WCP", value: "WCP" },
      ],
      RSC_State_National: [
        { key: "AUTO", value: "AUTO" },
        { key: "BOP", value: "BOP" },
        { key: "WCP", value: "WCP" },
      ],
      RSC_Rockhill: [
        { key: "AUTO", value: "AUTO" },
        { key: "BOP", value: "BOP" },
        { key: "EBL", value: "EBL" },
        { key: "WCP", value: "WCP" },
      ],
      SIG_Plaza: [
        { key: "AUTO", value: "AUTO" },
        { key: "PACKAGE", value: "PACKAGE" },
        { key: "WCP", value: "WCP" },
      ],
      Slice_Plaza: [
        { key: "AUTO", value: "AUTO" },
        { key: "BOP", value: "BOP" },
      ],
      Slice_Rockhill: [
        { key: "AUTO", value: "AUTO" },
        { key: "BOP", value: "BOP" },
        { key: "EBL", value: "EBL" },
      ],
    },
    Policy_Forms: [
      { key: type, value: type },
    ],

    AP_Docs: [
      { key: type, value: type },
    ],

    HR_LDR_COMP: [
      { key: "Award", value: "Award" },
      { key: "Grant", value: "Grant" },
    ],

    Internal_Audit: [
      { key: "Code of Conduct", value: "Code of Conduct" },
      { key: "Follow Up", value: "Follow Up" },
      { key: "Disclosure Form", value: "Disclosure Form" },
    ],

    Delinquent_Let: [
      { key: "LETTER 1", value: "LETTER 1" },
      { key: "LETTER 2", value: "LETTER 2" },
      { key: "LETTER 3", value: "LETTER 3" },
    ],

    DC_Audit: [
      { key: "January", value: "January" },
      { key: "February", value: "February" },
      { key: "March", value: "March" },
      { key: "April", value: "April" },
      { key: "May", value: "May" },
      { key: "June", value: "June" },
      { key: "July", value: "July" },
      { key: "August", value: "August" },
      { key: "September", value: "September" },
      { key: "October", value: "October" },
      { key: "November", value: "November" },
      { key: "December", value: "December" },
    ],

    Employee_File: [
      { key: type + " APPLICATION", value: type + " APPLICATION" },
      { key: type + " CANCELLATION", value: type + " CANCELLATION" },
      { key: type + " CHANGES", value: type + " CHANGES" },
      { key: type + " CORRESPONDENCE", value: type + " CORRESPONDENCE" },
      { key: type + " FLOOD POLICY", value: type + " FLOOD POLICY" },
      { key: type + " MISC", value: type + " MISC" },
      { key: type + " OPTION SELECTORS", value: type + " OPTION SELECTORS" },
      { key: type + " PHOTOS", value: type + " PHOTOS" },
      { key: type + " RCE", value: type + " RCE" },
      { key: type + " SCHEDULES", value: type + " SCHEDULES" }
    ],

    HR_MVR: [
      { key: "Authorization", value: "Authorization" },
      { key: "Clear", value: "Clear" },
      { key: "Violation", value: "Violation" },
    ],

    HR_Relocate: [
      { key: "Closing Exp", value: "Closing Exp" },
      { key: "Equity Calculation", value: "Equity Calculation" },
      { key: "Home Buy", value: "Home Buy" },
      { key: "Home Sell", value: "Home Sell" },
      { key: "House Hunting Exp", value: "House Hunting Exp" },
      { key: "Household Goods", value: "Household Goods" },
      { key: "Initiation", value: "Initiation" },
      { key: "Miscellaneous", value: "Miscellaneous" },
      { key: "Taxes", value: "Taxes" },
      { key: "Temporary Living", value: "Temporary Living" },
      { key: "W2", value: "W2" }
    ],
  };
  // console.log("returning", descriptionsMap[documentType])
  if ((documentType === "HR") || (documentType === "Red_Deal")) {
    return descriptionsMap[documentType][type]
  }
  return descriptionsMap[documentType]

};

export const documentFormats = [
  { key: "BMP", value: "BMP" },
  { key: "CSV", value: "CSV" },
  { key: "DOC", value: "DOC" },
  { key: "DOCX", value: "DOCX" },
  { key: "DOT", value: "DOT" },
  { key: "GIF", value: "GIF" },
  { key: "HTM", value: "HTM" },
  { key: "HTML", value: "HTML" },
  { key: "JPE", value: "JPE" },
  { key: "JPEG", value: "JPEG" },
  { key: "JPG", value: "JPG" },
  { key: "MHT", value: "MHT" },
  { key: "MHTML", value: "MHTML" },
  { key: "MP3", value: "MP3" },
  { key: "PDF", value: "PDF" },
  { key: "PNG", value: "PNG" },
  { key: "PPT", value: "PPT" },
  { key: "PPTX", value: "PPTX" },
  { key: "RTF", value: "RTF" },
  { key: "TIF", value: "TIF" },
  { key: "TIFF", value: "TIFF" },
  { key: "TXT", value: "TXT" },
  { key: "VSD", value: "VSD" },
  { key: "XLS", value: "XLS" },
  { key: "XLSX", value: "XLSX" },
  { key: "XLT", value: "XLT" },
  { key: "bmp", value: "bmp" },
  { key: "csv", value: "csv" },
  { key: "doc", value: "doc" },
  { key: "docx", value: "docx" },
  { key: "dot", value: "dot" },
  { key: "gif", value: "gif" },
  { key: "htm", value: "htm" },
  { key: "html", value: "html" },
  { key: "jpe", value: "jpe" },
  { key: "jpeg", value: "jpeg" },
  { key: "jpg", value: "jpg" },
  { key: "mht", value: "mht" },
  { key: "mhtml", value: "mhtml" },
  { key: "mp3", value: "mp3" },
  { key: "pdf", value: "pdf" },
  { key: "png", value: "png" },
  { key: "ppt", value: "ppt" },
  { key: "pptx", value: "pptx" },
  { key: "rtf", value: "rtf" },
  { key: "tif", value: "tif" },
  { key: "tiff", value: "tiff" },
  { key: "txt", value: "txt" },
  { key: "vsd", value: "vsd" },
  { key: "xls", value: "xls" },
  { key: "xlsx", value: "xlsx" },
  { key: "xlt", value: "xlt" }
];

export const journalTypesList = [
  { key: "BUDJE", value: "BUDJE" },
  { key: "CCRNG", value: "CCRNG" },
  { key: "CJ", value: "CJ" },
  { key: "CR", value: "CR" },
  { key: "GJ", value: "GJ" },
  { key: "IJ", value: "IJ" },
  { key: "LNCR", value: "LNCR" },
  { key: "LNRRG", value: "LNRRG" },
  { key: "PAYRL", value: "PAYRL" },
  { key: "PLJ", value: "PLJ" },
  { key: "REVJE", value: "REVJE" },
  { key: "RJ", value: "RJ" },
  { key: "OPT", value: "OPT" },
  { key: "NRGJE", value: "NRGJE" },
  { key: "ACHD", value: "ACHD" },
];

export const agencyDocsTypesList = [
  { key: "Change_Requests", value: "Change Requests" },
  { key: "Contract", value: "Contract" },
  { key: "Letters", value: "Letters" },
  { key: "Miscellaneous", value: "Miscellaneous" },
  { key: "Original_File", value: "Original File" },
  { key: "Prospect", value: "Prospect" },
  { key: "State_Forms", value: "State Forms" },
];
export const producerDocsTypesList = [
  { key: "Change_Requests", value: "Change Requests" },
  { key: "Letters", value: "Letters" },
  { key: "Original_File", value: "Original File" },
  { key: "Personal_Info", value: "Personal Info" },
  { key: "State_Forms", value: "State Forms" },
];

export const hrTypeList = [
  { key: "Attendance", value: "Attendance" },
  { key: "Benefits", value: "Benefits" },
  { key: "Payroll", value: "Payroll" },
  { key: "Personal", value: "Personal" },
  { key: "Termination", value: "Termination" },
  { key: "Welfare_Benefits", value: "Welfare Benefits" },
];

export const itvProjectCompanyList = [
  { key: "Beacon", value: "Beacon" },
  { key: "Patrons_Not_V6_or_V7", value: "Patrons (Not V6 or V7)" },
  { key: "State_Auto", value: "State Auto" },
];

export const beaconCompanyList = [{ key: "Beacon", value: "Beacon" }];

export const bondsCompanyList = [{ key: "State_Auto", value: "State Auto" }];

export const rtwSystemCompanyList = [{ key: "RTW", value: "RTW" }];

export const largeLineDecCompanyList = [{ key: "Large_Line_Dec", value: "Large Line Dec" }];

export const redDealTypeList = [
  { key: "FSM_Companion", value: "FSM - Companion" },
  { key: "FSM_Rockhill", value: "FSM - Rockhill" },
  { key: "FSM_State National", value: "FSM - State National" },
  { key: "RSC_Companion", value: "RSC - Companion" },
  { key: "RSC_Plaza", value: "RSC - Plaza" },
  { key: "RSC_State National", value: "RSC - State National" },
  { key: "RSC_Rockhill", value: "RSC - Rockhill" },
  { key: "SIG_Plaza", value: "SIG - Plaza" },
  { key: "Slice_Plaza", value: "Slice - Plaza" },
  { key: "Slice_Rockhill", value: "Slice - Rockhill" },
];

export const hrcreditcardtypemenu = [{ key: "Credit_Card", value: "Credit Card" }];

export const investmentsecurities = [
  { key: "AL", value: "AL" },
  { key: "AK", value: "AK" },
  { key: "AZ", value: "AZ" },
  { key: "AR", value: "AR" },
  { key: "CA", value: "CA" },
  { key: "CO", value: "CO" },
  { key: "CT", value: "CT" },
  { key: "DE", value: "DE" },
  { key: "FL", value: "FL" },
  { key: "GA", value: "GA" },
  { key: "HI", value: "HI" },
  { key: "ID", value: "ID" },
  { key: "IL", value: "IL" },
  { key: "IN", value: "IN" },
  { key: "IA", value: "IA" },
  { key: "KS", value: "KS" },
  { key: "KY", value: "KY" },
  { key: "LA", value: "LA" },
  { key: "ME", value: "ME" },
  { key: "MD", value: "MD" },
  { key: "MA", value: "MA" },
  { key: "MI", value: "MI" },
  { key: "MN", value: "MN" },
  { key: "MS", value: "MS" },
  { key: "MO", value: "MO" },
  { key: "MT", value: "MT" },
  { key: "NE", value: "NE" },
  { key: "NV", value: "NV" },
  { key: "NH", value: "NH" },
  { key: "NJ", value: "NJ" },
  { key: "NM", value: "NM" },
  { key: "NY", value: "NY" },
  { key: "NC", value: "NC" },
  { key: "ND", value: "ND" },
  { key: "OH", value: "OH" },
  { key: "OK", value: "OK" },
  { key: "OR", value: "OR" },
  { key: "PA", value: "PA" },
  { key: "RI", value: "RI" },
  { key: "SC", value: "SC" },
  { key: "SD", value: "SD" },
  { key: "UT", value: "UT" },
  { key: "VT", value: "VT" },
  { key: "VA", value: "VA" },
  { key: "WA", value: "WA" },
  { key: "WV", value: "WV" },
  { key: "WI", value: "WI" },
  { key: "WY", value: "WY" },
]

export const investmentCUSIP = [
  { key: "518_Property_Management_and_Le", value: "518 Property Management and Le" },
  { key: "American_Compensation_Ins_Co", value: "American Compensation Ins Co" },
  { key: "Beacon_Lloyds_Ins_Co", value: "Beacon Lloyds Ins Co" },
  { key: "Beacon_National_Ins_Co", value: "Beacon National Ins Co" },
  { key: "Bloomington_Compensation_Ins_C", value: "Bloomington Compensation Ins C" },
  { key: "Broadstreet_Capital_Partners", value: "Broadstreet Capital Partners" },
  { key: "Farmers_Casualty", value: "Farmers Casualty" },
  { key: "Litchfield_Mutual", value: "Litchfield Mutual" },
  { key: "Meridian_Citizens_Mutual_Ins_C", value: "Meridian Citizens Mutual Ins C" },
  { key: "Meridian_Insurance_Group_Inc", value: "Meridian Insurance Group Inc" },
  { key: "Meridian_Security_Ins_Co", value: "Meridian Security Ins Co" },
  { key: "Milbank", value: "Milbank" },
  { key: "Patrons_Mutual_of_CT", value: "Patrons Mutual of CT" },
  { key: "Pension_Fund", value: "Pension Fund" },
  { key: "Plaza_Ins_Company", value: "Plaza Ins Company" },
  { key: "Retirement_401H", value: "Retirement 401H" },
  { key: "Rockhill_Holding_Company", value: "Rockhill Holding Company" },
  { key: "Rockhill_Ins_Company", value: "Rockhill Ins Company" },
  { key: "SA_Software", value: "SA Software" },
  { key: "State_Auto_Financial_Corp", value: "State Auto Financial Corp" },
  { key: "State_Auto_Florida_Ins", value: "State Auto Florida Ins" },
  { key: "State_Auto_Foundation", value: "State Auto Foundation" },
  { key: "State_Auto_Ins_Co_of_Ohio", value: "State Auto Ins Co of Ohio" },
  { key: "State_Auto_Ins_Co_of_Wisconsin", value: "State Auto Ins Co of Wisconsin" },
  { key: "State_Automobile_Mutual", value: "State Automobile Mutual" },
  { key: "State_Auto_National_", value: "State Auto National " },
  { key: "State_Auto_Prop_and_Cas", value: "State Auto Prop and Cas" },
  { key: "Stateco_Financial_Services", value: "Stateco Financial Services" },
]

export const investmentslist = [
  { key: "CUSIP", value: "CUSIP" },
  { key: "Securities_on_Deposit", value: "Securities on Deposit" },
  { key: "Trust_Docs", value: "Trust Docs" },
]

export let dateofLoss = [];
for (let i = 0; i < 7; i++) {
  let date = new Date(); // Create a new Date object in each iteration
  date.setDate(date.getDate() - i);
  dateofLoss[i] = {
    key: date.toLocaleDateString('en-US') + "",
    value: date.toLocaleDateString('en-US') + ""
  };
}

export const assnCorpTypeList = [
  { key: "Communications", value: "Communications" },
  { key: "Documents", value: "Documents" },
  { key: "Original_File", value: "Original File" },
  { key: "Reports", value: "Reports" }
];

export const assnProgTypeList = [
  { key: "Communications", value: "Communications" },
  { key: "Documents", value: "Documents" },
  { key: "Original_File", value: "Original File" },
  { key: "Reports", value: "Reports" }
];

export const assnCorpReportsList = [{ key: "Corporate_Reports", value: "Corporate Reports" }];

export const adminEnvTypeList = [{ key: "Envelopes", value: "Envelopes" }];

export const adminFormTypeList = [{ key: "Forms", value: "Forms" }];

export const adjFileRegionList = [
  { key: "Beacon", value: "Beacon" },
  { key: "Columbus", value: "Columbus" },
  { key: "Des_Moines", value: "Des Moines" },
  { key: "Harrisburg", value: "Harrisburg" },
  { key: "Home_Office", value: "Home Office" },
  { key: "Indianapolis", value: "Indianapolis" },
  { key: "Nashville", value: "Nashville" },
  { key: "Rockhill", value: "Rockhill" },
  { key: "RTW", value: "RTW" }
];

export const policyFormTypeList = [{ key: "Policy_Forms", value: "Policy Forms" }];

export const hrRelocateTypeList = [{ key: "HR_Relocate", value: "HR Relocate" }];

export const hrMvrTypeList = [{ key: "HR_MVR", value: "HR MVR" }];

export const empFileCompanyList = [{ key: "Insurance_Services_Agency", value: "Insurance Services Agency" }];

export const claimDataTypeList = [{ key: "Claim_Data", value: "Claim Data" }];

export const billDataTypeList = [{ key: "Bill_Data", value: "Bill Data" }];

export const contractTypeList = [

  { key: "Reinsurance", value: "Reinsurance" },
  { key: "Internal_Admin", value: "Internal Admin" },
  { key: "Consulting", value: "Consulting" },
  { key: "IT_Systems", value: "IT Systems" },
  { key: "Lease_Properties", value: "Lease Properties" },
  { key: "Maintenance", value: "Maintenance" },
  { key: "Other", value: "Other" }

]

export const commTypeList = [

  { key: "Agent_Bill", value: "Agent Bill" },
  { key: "Direct_Bill", value: "Direct Bill" }

]

export const leaseTypeList = [

  { key: "Property_PROP", value: "Property [PROP ]" },
  { key: "Schedule_SCHED", value: "Schedule [SCHED ]" },
  { key: "Vehicle_VEH", value: "Vehicle [VEH ]" }

]

export const lossControlTypeList = [

  { key: "Certificate", value: "Certificate" },
  { key: "Filing_Mutual", value: "Filing Mutual" },
  { key: "Filing_Other", value: "Filing Other" },
  { key: "Filing_PC", value: "Filing PC" },
  { key: "Filing_Sammi", value: "Filing Sammi" },
  { key: "Monthly_Auto", value: "Monthly Auto" },
  { key: "Monthly_Liability", value: "Monthly Liability" },
  { key: "Monthly_WCP", value: "Monthly WCP" }

]

export const currentCarrierList = [{ key: "Current_Carrier", value: "Current Carrier" }];

export const policyComplainTypeList = [

  { key: "Follow_Up", value: "Follow Up" },
  { key: "Original", value: "Original" }

]

export const r3ContractTypeList = [

  { key: "RED_Contract", value: "RED Contract" },
  { key: "RED_Support", value: "RED Support" },
  { key: "Rockhill_Contract", value: "Rockhill Contract" },
  { key: "Rockhill_Support", value: "Rockhill Support" },
  { key: "Lease_Properties", value: "Lease Properties" },
  { key: "RTW_Contract", value: "RTW Contract" },
  { key: "RTW_Support", value: "RTW Support" }

]

export const reinsuranceTypeList = [

  { key: "LOSSES", value: "LOSSES" },
  { key: "PREMIUM", value: "PREMIUM" },
  { key: "MISC", value: "MISC" }

]

export const rhodeTypeList = [

  { key: "DEC_Pages", value: "DEC Pages" }

]

export const acctReconIndexList = [{ key: "Reconciliation", value: "Reconciliation" }];

export const acctReconTypeList = [

  { key: "BCWS_A/R", value: "BCWS A/R" },
  { key: "BCMS_A/R", value: "BCMS A/R" },
  { key: "V6_A/R", value: "V6 A/R" },
  { key: "SALV/SUB", value: "SALV/SUB" },
  { key: "LOSSES", value: "LOSSES" },
  { key: "PREMIUM_REFUND", value: "PREMIUM REFUND" }

]
export const accountingTypeList = [

  { key: "Active_Agents", value: "Active Agents" },
  { key: "Cancelled_Agents", value: "Cancelled Agents" },
  { key: "QPA_Adjustments", value: "QPA Adjustments" },
  { key: "Quick_Pay", value: "Quick Pay" },
  { key: "6_MO_Settle_Up", value: "6 MO Settle Up" },
  { key: "DB_Com_Dir_Dep", value: "DB Com Dir Dep" },
  { key: "Sweep_Auth", value: "Sweep Auth" }

]

export const bnkReconBRIndexList = [{ key: "Branch", value: "Branch" }];

export const bnkReconBRTypeList = [

  { key: "Cincinnati", value: "Cincinnati" },
  { key: "Cleveland", value: "Cleveland" },
  { key: "DBO", value: "DBO" },
  { key: "ERO", value: "ERO" },
  { key: "LBO", value: "LBO" },
  { key: "MRO", value: "MRO" },
  { key: "NRO", value: "NRO" },
  { key: "SRO", value: "SRO" },
  { key: "SWR", value: "SWR" }

]

export const bnkReconCorpIndexList = [{ key: "Corporate", value: "Corporate" }];

export const bnkReconCorpTypeList = [

  { key: "401", value: "401" },
  { key: "ANALYSIS_STMT", value: "ANALYSIS STMT" },
  { key: "ASA", value: "ASA" },
  { key: "BCP", value: "BCP" },
  { key: "BHF", value: "BHF" },
  { key: "BIG", value: "BIG" },
  { key: "BLC", value: "BLC" },
  { key: "BLI", value: "BLI" },
  { key: "BNI", value: "BNI" },
  { key: "CAP", value: "CAP" },
  { key: "CMI", value: "CMI" },
  { key: "FAC", value: "FAC" },
  { key: "FAR", value: "FAR" },
  { key: "FPI", value: "FPI" },
  { key: "GIN", value: "GIN" },
  { key: "LMI", value: "LMI" },
  { key: "MBK", value: "MBK" },
  { key: "MCM", value: "MCM" },
  { key: "MCS", value: "MCS" },
  { key: "MID", value: "MID" },
  { key: "MIG", value: "MIG" },
  { key: "MMF", value: "MMF" },
  { key: "MMI", value: "MMI" },
  { key: "MSC", value: "MSC" },
  { key: "MSI", value: "MSI" },
  { key: "PEN", value: "PEN" },
  { key: "PIC", value: "PIC" },
  { key: "PMI", value: "PMI" },
  { key: "PML", value: "PML" },
  { key: "PRI", value: "PRI" },
  { key: "PSI", value: "PSI" },
  { key: "RET", value: "RET" },
  { key: "SAM", value: "SAM" },
  { key: "SAN", value: "SAN" },
  { key: "SFL", value: "SFL" },
  { key: "SFS", value: "SFS" },
  { key: "SIS", value: "SIS" },
  { key: "SOH", value: "SOH" },
  { key: "SPC", value: "SPC" },
  { key: "STF", value: "STF" },
  { key: "SWI", value: "SWI" }

]

export const auditItemList = [{ key: "Program_Input/Output", value: "Program Input/Output" }];

export const auditTypeList = [

  { key: "Summary_Data", value: "Summary Data" },
  { key: "Tracking_Table", value: "Tracking Table" },
  { key: "Notes", value: "Notes" }

]

export const dataQualityList = [
  { key: "1st_Quarter", value: "1st Quarter" },
  { key: "2nd_Quarter", value: "2nd Quarter" },
  { key: "3rd_Quarter", value: "3rd Quarter" },
  { key: "4th_Quarter", value: "4th Quarter" },

]


